import React, { Component } from 'react'

export default class Play extends Component {
  render() {
    const {isStop} = this.props;
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        id="svg8"
        version="1.1"
        viewBox="23 20 24 32"
        height="48"
        width="48">
        <defs
          id="defs2" />
        <g
          id="layer1">
          <circle
            r="16"
            cy="36.260414"
            cx="35.07143"
            id="path10"
            style={{ fill: 'orange', strokeWidth: 1.32291667, stroke: 'white' }} />
          <path
            d={ isStop?"m 28.333333,29.666667 H 41.666666 V 43 H 28.333333 z":"m 44.731651,36.257809 -7.44948,4.300959 -7.44948,4.300959 0,-8.601919 0,-8.601918 7.44948,4.300959 z"}
            id="path817"
            style={{ fill: 'white', strokeWidth: 1.32291667, stroke: 'orange' }} />
        </g>
      </svg>
    )
  }
}
